import { Routes } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
const ɵ0 = () => import("./pages/users/sign-in/sign-in.module.ngfactory").then((m) => m.SignInModuleNgFactory), ɵ1 = () => import("./pages/users/sign-in-tecnico/sign-in-tecnico.module.ngfactory").then((m) => m.SignInTecnicoModuleNgFactory), ɵ2 = () => import("./pages/users/change-password/change-password.module.ngfactory").then((m) => m.ChangePasswordModuleNgFactory), ɵ3 = () => import("./pages/users/two-factor/two-factor.module.ngfactory").then((m) => m.TwoFactorModuleNgFactory), ɵ4 = () => import("./pages/users/confirm-email/confirm-email.module.ngfactory").then((m) => m.ConfirmEmailModuleNgFactory), ɵ5 = () => import("./pages/users/sign-in-tecnico/sign-in-tecnico.module.ngfactory").then((m) => m.SignInTecnicoModuleNgFactory), ɵ6 = () => import("./pages/users/forgot-password/forgot-password.module.ngfactory").then((m) => m.ForgotPasswordModuleNgFactory), ɵ7 = () => import("./pages/users/register/register.module.ngfactory").then((m) => m.RegisterModuleNgFactory), ɵ8 = () => import("./pages/sub-category/sub-category.module.ngfactory").then((m) => m.SubCategoryModuleNgFactory), ɵ9 = () => import("./pages/sub-category/sub-category.module.ngfactory").then((m) => m.SubCategoryModuleNgFactory), ɵ10 = () => import("./pages/transaction-type-detail/transaction-type-detail.module.ngfactory").then((m) => m.TransactionTypeDetailModuleNgFactory), ɵ11 = () => import("./pages/profile-picker/profile-picker.module.ngfactory").then((m) => m.ProfilePickerModuleNgFactory), ɵ12 = () => import("./pages/transaction-parent-list/transaction-parent-list.module.ngfactory").then((m) => m.TransactionParentListModuleNgFactory), ɵ13 = () => import("./pages/transaction/transaction-management.module.ngfactory").then((m) => m.TransactionManagementModuleNgFactory), ɵ14 = () => import("./pages/transaction-admin/transaction-admin-management.module.ngfactory").then((m) => m.TransactionAdminManagementModuleNgFactory), ɵ15 = () => import("./pages/transaction-receipt/transaction-receipt.module.ngfactory").then((m) => m.TransactionReceiptModuleNgFactory), ɵ16 = () => import("./pages/transaction-plan-receipt/transaction-plan-receipt.module.ngfactory").then((m) => m.TransactionPlanReceiptModuleNgFactory), ɵ17 = () => import("./pages/shopping-cart/shopping-cart.module.ngfactory").then((m) => m.ShoppingCartModuleNgFactory), ɵ18 = () => import("./pages/account/account.module.ngfactory").then((m) => m.AccountModuleNgFactory), ɵ19 = () => import("./pages/credit/credit.module.ngfactory").then((m) => m.CreditModuleNgFactory), ɵ20 = () => import("./pages/fine/external-fine.module.ngfactory").then((m) => m.ExternalFineModuleNgFactory), ɵ21 = () => import("./pages/shared/privacy/privacy.module.ngfactory").then((m) => m.PrivacyModuleNgFactory), ɵ22 = () => import("./pages/shared/terms/terms.module.ngfactory").then((m) => m.TermsModuleNgFactory), ɵ23 = () => import("./pages/shared/transaction-supplementary-documents-list/transaction-supplementary-documents-list.module.ngfactory").then((m) => m.TransactionSupplementaryDocumentsListModuleNgFactory), ɵ24 = () => import("./pages/franchises/franchises.module.ngfactory").then((m) => m.FranchisesModuleNgFactory), ɵ25 = () => import("./pages/medical-certificate/medical-certificate.module.ngfactory").then((m) => m.MedicalCertificateModuleNgFactory), ɵ26 = () => import("./pages/my-request/my-request.module.ngfactory").then((m) => m.MyRequestModuleNgFactory), ɵ27 = () => import("./pages/licesing-discipline-form/licesing-discipline-form.module.ngfactory").then((m) => m.LicesingDisciplineFormModuleNgFactory), ɵ28 = () => import("./pages/medical-registration-renewal-request/medical-registration-renewal-request.module.ngfactory").then((m) => m.MedicalRegistrationRenewalRequestModuleNgFactory), ɵ29 = () => import("./pages/certificate-qr-validation/certificate-qr-validation.module.ngfactory")
    .then((m) => m.CertificateQrValidationModuleNgFactory), ɵ30 = () => import("./pages/user-process-qr-validation/user-process-qr-validation.module.ngfactory")
    .then((m) => m.UserProcessQrValidationModuleNgFactory);
const routes = [
    {
        path: 'welcome',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: ɵ0,
    },
    {
        path: 'login-admin',
        loadChildren: ɵ1,
    },
    {
        path: 'changePassword',
        loadChildren: ɵ2,
    },
    {
        path: 'two-factor',
        loadChildren: ɵ3,
    },
    {
        path: 'confirm-email',
        loadChildren: ɵ4,
    },
    {
        path: 'login-tecnico',
        loadChildren: ɵ5,
    },
    {
        path: 'forgotPassword',
        loadChildren: ɵ6,
    },
    {
        path: 'register',
        loadChildren: ɵ7,
    },
    {
        path: 'available-transactions',
        loadChildren: ɵ8,
    },
    {
        path: '',
        loadChildren: ɵ9,
    },
    {
        path: 'transaction-type',
        loadChildren: ɵ10,
    },
    {
        path: 'transaction-type/profile',
        loadChildren: ɵ11,
    },
    {
        path: 'transaction-type/parent-list',
        loadChildren: ɵ12,
    },
    {
        path: 'transactions',
        loadChildren: ɵ13,
    },
    {
        path: 'transactions-admin',
        loadChildren: ɵ14,
    },
    {
        path: 'transaction-receipt',
        loadChildren: ɵ15,
    },
    {
        path: 'transaction-plan-receipt',
        loadChildren: ɵ16,
    },
    {
        path: 'shopping-cart',
        loadChildren: ɵ17,
    },
    /*
      {
        path: 'reports',
        loadChildren: () =>
          import('src/app/pages/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: 'my-certifications',
        loadChildren: () =>
          import('src/app/pages/my-certifications/my-certifications.module').then(
            (m) => m.MyCertificationsModule
          ),
      },
    */
    {
        path: 'account',
        loadChildren: ɵ18,
    },
    {
        path: 'credit-purchase',
        loadChildren: ɵ19,
    },
    {
        path: 'fine-list',
        loadChildren: ɵ20,
    },
    {
        path: 'privacy',
        loadChildren: ɵ21,
    },
    {
        path: 'terms',
        loadChildren: ɵ22,
    },
    {
        path: 'user-process-document-request/requestId/:id',
        loadChildren: ɵ23,
    },
    // {
    //   path: '',
    //   loadChildren: () =>
    //     import('src/app/pages/category-detail/category-detail.module').then((m) => m.CategoryDetailModule),
    // },
    /*   {
        path: 'certifications',
        loadChildren: () =>
          import('./pages/certifications/certification.module').then((m) => m.CertificationsModule),
      },   */
    {
        path: 'franchises',
        loadChildren: ɵ24,
    },
    {
        path: 'medical-certificates',
        loadChildren: ɵ25,
    },
    {
        path: 'my-request',
        loadChildren: ɵ26,
    },
    {
        path: 'medical-profile',
        loadChildren: ɵ27,
    },
    {
        path: 'medical-registration-renewal',
        loadChildren: ɵ28,
    },
    {
        path: 'qrcode/validateCertificate/:id',
        loadChildren: ɵ29,
    },
    {
        path: 'qrcode/:id',
        loadChildren: ɵ30,
    },
    // {
    //   path: 'medical-professional-search',
    //   loadChildren: () => import('src/app/core/components/citizen-doctor-search/citizen-doctor-search.module')
    //     .then(m => m.CitizenDoctorSearchModule)
    // },
    // {
    //   path: 'operational-dashboard',
    //   loadChildren: () =>
    //     import('src/app/pages/operational-dashboard/operational-dashboard.module').then(
    //       (m) => m.OperationalDashboardModule
    //     ),
    // },
    { path: '**', component: PageNotFoundComponent },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30 };
